import * as Cesium from 'cesium';
import MapUtil from '../util/mapUtil';
/**
 * 基础图层
 */
class BaseLayer{

    constructor(options){
        this.layerName=options.layerName;//图层名
        this.dataSource = new Cesium.CustomDataSource(this.layerName);//初始化数据源
        window.gisViewer.dataSources.add(this.dataSource);//添加病害数据源
        MapUtil.addLayer(this);
    }

    /**
     * 删除
     * @param {*} id 
     */
    removeEntityById(id){
        this.dataSource.entities.removeById(id);
    }

    /**
     * 获取
     * @param {*} id 
     */
    getEntityById(id){
        return this.dataSource.entities.getById(id);
    }

    /**
     * 显示、隐藏
     */
    setVisible(visible){
        this.dataSource.show=visible;
    }

    /**
     * 获取显示状态
     */
    getVisible(){
        return this.dataSource.show;
    }

    /**
     * 获取所有实体
     */
    getEntities(){
        return this.dataSource.entities;
    }

    /**
     * 清除
     */
    clearLayer(){
        this.dataSource.entities.removeAll();
    }

    /**
     * 销毁
     */
    destroy(){
        MapUtil.removeLayer(this);
    }
}

export default BaseLayer;